<app-group-header [Heading]="'Ladeverlauf'"
				  [chart]="chart"
				  [info]="info"
				  (chartEvent)="getChartEvent($event)"
				  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Ladung'"
					  [Error]="charge?.isError"
					  [ErrorLevel]="charge?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[charge?.TimeseriesData]"
					  [Unit]="'%'"
					  [Legend]="['Ladung']"
					  [Info]="'Zeitlicher Verlauf der OLPS-Ladung.'"
					  [resizeEvent]="childResizeEvent"
					  [ChartType]="'line'">
	</app-default-card>

</div>
